import React from 'react';
import {connect} from "react-redux";
import RewardDetail from "../components/RewardDetail";
import RewardNotFoundComponent from "../components/RewardNotFoundComponent";

class RewardDetailContainer extends React.Component {

    render() {
        if(this.props.reward === null){
            if(this.props.error){
                switch(this.props.error){
                    case "REWARD_NOT_FOUND":
                        return <RewardNotFoundComponent/>
                    default: return null;
                }
            }

            return null;
        }

        return <div>
            <RewardDetail key={this.props.reward.id}
                          subtitle={this.props.reward.subtitle}
                          location={this.props.reward.location}
                          description={this.props.reward.description}
                          terms={this.props.reward.terms} />
        </div>
    }
}

export default connect (
    (state) => {
        return {
            reward: state.reward.item,
            error: state.reward.error
        }
    }
) (RewardDetailContainer)